import { Model } from "./model";
import { Packshot } from "./packshot.model";
import { Quiz } from "./quiz.model";

export class Product extends Model {
    id: number;
    brand_id: number;
    product_category_id: number;
    name: string;
    ref: number;
    logo: string;
    product_logo_url: string;
    packshot_3d: string;
    packshot_3d_url: string;
    icons: string;
    icons_url: string;
    id_card: string;
    id_card_url: string;
    animation: string;
    animation_url: string;
    apk: string;
    apk_url: string;
    brand_name: string;
    product_category_name: string;
    packshots: Packshot[];
    quizzes: Quiz[];
}



// WEBPACK FOOTER //
// ./src/models/product.model.ts